export const getLink = (name: string, to: string) => ({ name, to });

export const devEnv = process.env["NODE_ENV"] === "development";
